import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Text from '../../../../elements/Typo/Text'

import { ExperimentDetailsI } from '../../../../_config/types'
import { PiTarget } from 'react-icons/pi'
import CaptureDecisionModal from '../../../../components/modal/CaptureDecision.modal'
import { trackEvent } from '../../../../_common/functions'

interface Props {
    experiment: ExperimentDetailsI
}

const CaptureDecision: React.FC<Props> = ({ experiment }) => {
    const { t } = useTranslation()
    const captureDecisionModal: any = useRef()

    const _handleShowCaptureDecision = () => {
        trackEvent('experiment_details_capture_decision_opened', { experiment_literal: experiment?.experiment_literal })
        captureDecisionModal.current?.showModal()
    }

    return (
        <>
            <button type="button" onClick={_handleShowCaptureDecision} className="flex gap-[0.33rem] bg-[#F1F1F1] items-center rounded-[1.045rem] !font-semibold pl-1 pr-3 whitespace-nowrap">
                <div className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center">
                    <PiTarget size="0.66rem" />
                </div>
                <Text size="xs" className="!text-[0.591rem] !font-semibold">
                    {t('Business Decision')}
                </Text>
            </button>

            {experiment?.experiment_literal && <CaptureDecisionModal _ref={captureDecisionModal} experiment={experiment} />}
        </>
    )
}

export default CaptureDecision
